<button [type]="type()" [disabled]="disabled()" [class]="rootClasses()">
  <span class="flex items-center gap-2">
    <ng-content></ng-content>
  </span>
</button>
